<template>
<div>
<el-row>
<el-col :span="4"><div class="grid-content"></div></el-col>
<el-col :span="16">
<div class="title">
<h1>基于价值的虚拟博物馆用户交互设计模型</h1>
</div>
</el-col>
<el-col :span="4"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="8"><div class="grid-content"></div></el-col>
<el-col :span="8">
<div class="picture">
<img src="../assets/project13_1.jpg.webp"/>
</div>
</el-col>
<el-col :span="8"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20">
<div class="abstract">
                    随着数字技术的发展以及以人为本的理念在博物馆陈列设计中的普及，
                    基于VR（虚拟现实）的博物馆展览（虚拟现实ME）的用户体验逐渐被重视。还有
                    当今虚拟现实ME设计中技术与交互的融合需要解决很多问题。然而，
                    现有的博物馆展览设计框架没有结合虚拟现实技术的特点来解决
                    有针对性地解决 虚拟现实ME特有的问题。基于传统的用户体验框架，本文总结了
                    博物馆展览中用户体验的三个层次（卢克斯），并提出了独特的“创造级”体验
                    虚拟现实ME，构成了虚拟现实ME体验的闭环。然后本文对相关研究进行了分析
                    通过文献回顾和总结近年来技术应用的趋势和不同的交互
                    每个卢克斯出现的问题。基于文献分析结果，本文提出了虚拟现实ME的“玫瑰模型”。
                    该模型总结了展览技术、感官类型、卢克斯以及人展交互因素之间的关系，对虚拟现实ME设计具有一定的指导意义。
                    <div class="paper_published">
<br/><br/>Zou, N., Gong, Q.*, Zhou, J., Chen, P., Kong, W., & Chai, C. (2021). Value-based model of user interaction design for virtual museum. CCF Transactions on Pervasive Computing and Interaction, 3(2), 112–128. （SCI&CCF-B，学生一作）
                    </div>
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="8">
<div class="picture">
<img src="../assets/project13_2.jpg.webp"/>
</div>
</el-col>
<el-col :span="12">
<div class="sub-title">
                    虚拟现实ME的四个级别的用户体验
                </div>
<div class="text">

                    虚拟现实ME开发过程中的心得
                    设计研究、博物馆展览逐渐形成
                    用户体验的三个重要级别：工件级别、
                    行为层面、精神层面。感谢申请
                    虚拟现实技术在博物馆展览中的应用之四
                    另外用户体验水平也逐渐显现
                    这三个层次：创造层次。同时，
                    神器层、行为层、精神层三个层次
                    层也得到了升级，并赋能
                    虚拟现实技术。这四个经验等级分别是
                    不仅是观众的观展体验，更是博物馆展览的表达水平
                    信息
                </div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="12">
<div class="sub-title">
                    研究选择与分析
                </div>
<div class="text">
                    以下部分展示了文献如何
                    找到与 虚拟现实ME相关的信息以及如何过滤结果。
                    然后，对研究进行分类和分析
                    博物馆虚拟展览的三要素进行。
                    关键词“博物馆虚拟展览”被搜索
                    沃斯、科学直接 和 IEEE 电子数据库，以及
                    大部分文献是按照类型过滤掉的
                    文献和访问权。然后剩下的文献
                    浏览了一下，筛选出一些相关文献
                    只涉及网络技术，不涉及虚拟现实
                    技术，其余文献选自
                    涉及特定设计实践项目的研究论文。最终共筛选出42项研究。
                    <br/><br/>对筛选获得的文献进行了回顾并
                    根据以下标准对各文献中提到的虚拟现实ME病例进行分析。
                    <br/><br/>1.卢克斯：虚拟现实ME涉及的经验等级，包括神器等级（提到展品外观展示的案例）、行为等级（提到展品外观展示的案例）
                    展示功能模拟或活动模拟），
                    精神层面（提到氛围渲染的案例
                    和内涵建设）和创作水平
                    (提及关联和创作共享的案例）。
                    <br/><br/>  2. 海伊夫：虚拟现实ME设计中常见的交互因素。
                    <br/><br/>  一个。过滤关键词：结合李等人提出的博物馆展览体验用户测试维度。 (2020)
                    以及提出的人类展示互动因素
                    王 和 夏 (2019)，学习行为的类型
                    艾哈迈德等人提出。 (2014)，海伊夫总结如下：
                    <br/><br/>   – 学习：学习是最重要的功能
                    博物馆。学习的方式主要有以下三种
                    博物馆展览：认知学习、共情学习和社交学习。学习、感知、专注等关键词都被认为是提及
                    学习的因素。
                    <br/><br/>    – 情感：指观众在观展过程中的沉浸感和审美体验。关键词如情感、情感、享受、
                    享受、满足都属于情感因素。
                    <br/><br/>    – 易用性：指有用性、容错性、
                    系统的鲁棒性等。关键词如“轻松”
                    使用和有用性被认为是提及
                    系统的易用性。
                    <br/><br/>    – 行为意图：指用户访问的倾向
                    以及观展过程中的消费者行为等。关键词如意图、行为意图、
                    趋势等都被认为是提及因素
                    的行为意图。
                    <br/><br/>    b.审核标准：以上关键词均应出现
                    在“研究目的”、“评价”或“研究方法”部分，但不在“背景”、“引言”、
                    “文献综述”或“参考文献”部分。上下文和
                    满足上述标准的研究的意义将是
                    进一步判断。同时，阅读并判断研究成果
                    没有提及这些关键字但怀疑看到的
                    是否有任何研究也符合上述标准。
                </div>
</el-col>
<el-col :span="8">
<div class="picture">
<img src="../assets/project13_3.jpg.webp"/>
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20">
<div class="picture">
<img src="../assets/project13_4.png.webp"/>
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="8">
<div class="picture">
<img src="../assets/project13_5.jpg.webp"/>
<img src="../assets/project13_6.jpg.webp"/>
<img src="../assets/project13_7.jpg.webp"/>
<img src="../assets/project13_8.jpg.webp"/>
</div>
</el-col>
<el-col :span="12">
<div class="sub-title">
                    结果
                </div>
<div class="text">
                    通过文献查阅，发现有一些
                    四个卢克斯之间的连接。分析卢克斯和海伊夫之间的关系，我们可以得到模型
                    图9，因其形状像玫瑰，被称为“玫瑰模型”。该模型总结了之间的联系
                    展览技术、感官类型、卢克斯和 海伊夫
                    虚拟现实ME。
                   <br/><br/> 如图10所示，该模型分为四个
                    部分：(a)、(b)、(c)、(d)。 (a) 代表虚拟展览
                    以技术为中心，由于其沉浸性，将成为整个系统的核心和基础，
                    传统展示方式所不具备的多感知性、互动性、概念化特征，
                    创造出与传统博物馆展览不同的感官体验和互动因素。
                    <br/><br/>  (b)部分显示视觉、听觉和动觉感觉类型以及它们之间的关系。根据
                    从上面的分析来看，视觉体验涉及到一切
                    卢克斯和在所有这些中占主导地位，因此代表视觉的图形是一个完整的圆，均匀分布在四个
                    卢克斯。不过主要还是强调听觉体验
                    从行为层面向行为层面转变的过程中
                    精神层面，在创作中的作用较弱
                    水平。代表听觉的图形是一个不规则的凹凸
                    从神器等级逐渐上升并回落
                    在精神层面上，最高点位于
                    行为和精神层面的中间。代表动觉体验的图表与听觉体验相似
                    一，但位置略有不同，因为根据
                    从分析结果来看，动觉作用较强的是行为层面、精神层面和创造层面，主要是精神层面向创造层面转变的过程。
                    <br/><br/>(c)部分展示了四个卢克斯之间的关系。
                    四个卢克斯的关系一模一样
                    如图1所示并已在上面进行了解释。在这里他们
                    为了外观而重新排列在一个圆圈上
                    模型。
                    <br/><br/> (d) 部分展示了 海伊夫涵盖的各种内容
                    上面，认知、社交和共情学习是
                    不同的学习类型。更多的认知学习发生
                    在神器层面向行为层面的转变过程中，行为层面向精神层面的转变过程中会发生更多的共情学习，并且
                    社会学习主要发生在转变过程中
                    灵性层面到造物层面，以及从造物层面反馈到器物层面的过程中。图表
                    因此，这三者都是不规则升高的，并且最高点位置的分布也不同。图表
                    情感是一个完整的圆圈，在
                    神器等级对应的最高点，
                    表明情感在所有四个 卢克斯中都很明显，但是
                    工件级别往往是产生情感的主要 卢克斯。行为意图和易用性因素相似
                    以图形的形式，具有更多的行为意图，例如用户
                    消费和社会分享在此过程中显而易见
                    将精神层面转化为创造层面，同时
                    行为级别将产生更多的易用性问题
                    到自己的特点。
                    <br/><br/> 总之，在这个模型中，不同的感觉类型和
                    海伊夫与四个卢克斯具有空间对应关系。如果
                    图表在某个经历的位置有一个凹凸
                    水平，这意味着这种感觉类型在
                    某些经验水平之间的转换过程
                    或某些经验水平本身，或某些经验水平或某些经验之间的转化过程
                    水平本身可以更明显地产生一定的海伊夫。
                    <br/><br/>  当使用该模型作为设计参考时，您可以
                    选择项目所需的卢克斯，并从图中观察相应的感官类型和海伊夫。对于
                    例如，如果您需要针对行为级别进行设计，您
                    可以截取如图11所示的行为级别及其对应元素，得到如下信息：
                    行为层面的设计，需要尽量保证
                    视觉、动觉和听觉三种感觉类型
                    考虑认知学习和移情学习类型，并且
                    如果合适，您需要进行易用性测试。如果拦截扩大，可以获得更多洞察
                    以行为层面为中心（图12）：从工件层面到行为层面的转变过程
                    行为层面到精神层面的考虑
                    设计解决方案。神器级别可以支撑体验
                    的行为层面，并努力向
                    精神层面可以丰富体验。
                </div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20">
<div class="sub-title">
                    讨论
                </div>
<div class="text">
                    本文从博物馆虚拟展览技术的角度出发,对博物馆虚拟展览的研究进行了梳理。
                    通过近几年的展览，发现了三个主要
                    博物馆虚拟展览的要素是展览技术、EVM和IE。在文献综述的过程中，
                    发现展览技术的研究热点
                    逐渐倾向于更多的虚拟技术，例如
                    VR这几年。但MR的研究热度和
                    其他技术近年来也迅速崛起，
                    表明该领域的研究正在逐步开始
                    关注如何将真实展品或真实环境与虚拟技术相结合，而不仅仅局限于
                    绝对的虚拟博物馆。 新博物馆学诞生以来，无论技术如何发展，对博物馆学的关注
                    观众的观展体验有增无减。
                    注重良好的展会体验也是其中之一
                    现代博物馆与传统博物馆的重要区别。最后，本文提出了博物馆虚拟展览设计框架。通过这个框架，可以快速掌握博物馆的构成’s
                    虚拟展览系统。该框架可以帮助研究人员
                    深入理解虚拟现实ME的内涵。
                  <br/><br/>  根据这个框架，我们还可以得到一些
                    对未来 虚拟现实ME设计的见解

                    <br/><br/>  促进卢克斯向创作层面的转变
                    <br/><br/>  创世级是未来虚拟现实ME的重要体验关卡，创世级经验的形成依赖于神器级、行为级、精神级的逐级支撑。
                    <br/><br/>      总之，提升经验创造等级主要有两个步骤：一是提升神器等级、行为等级、精神等级的经验；二是提升神器等级、行为等级、精神等级的经验；二是促进神器级体验向行为级、精神级、创造级体验的转化。
                    <br/><br/>   从文献综述的结果可以发现，现阶段的虚拟现实ME案例大多集中在神器层面体验的研究，而与行为层面、精神层面、创造层面体验相关的研究相对较少。未来的虚拟现实ME研究可以更加深化行为和精神层面的体验，通过丰富感官类型和优化各个海伊夫，促进体验层面向创造层面的转化。
                    <br/><br/> 丰富虚拟现实ME涉及的感官类型
                    <br/><br/>   根据不同的理论，人类的感官有视觉、听觉、嗅觉、味觉、动觉、触觉等多种感觉。目前虚拟现实ME中广泛应用的只有视觉、听觉、动觉和触觉，其中视觉和听觉仍然占据主要地位。
                    <br/><br/>   除了视觉和听觉体验之外，未来的 虚拟现实ME研究还需要优化动觉和基于动觉的触觉。此外，增加气味、热、冷等其他感官类型的体验也将是虚拟现实ME交互的一大创新。当感官类型丰富时，可以利用“联觉”的概念来创造更丰富的多模态感官体验。
                    <br/><br/>   激发观众的社交和同理心学习
                    <br/><br/>   观众在博物馆虚拟展览中的学习类型以认知学习为主，社交学习和情感学习为辅。博物馆是一个公共和主题场景，是社交和情感学习的理想场所。这将博物馆与教室或其他教育场景区分开来。因此，如何利用展览技术来激发观众的社会性和情感性学习类型将是未来值得研究的课题。
                    <br/><br/>   虚拟现实技术会在一定程度上阻碍人与人之间的互动，因此为了促进社交学习，在应用VR技术应用时，我们可以利用设备联网来尝试多人协作。当使用AR或MR技术时，我们可以通过投影或其他共享屏幕的方式在人与人之间创建一个交流上下文。在展览内容的开发上，可以增加两人或多人的合作游戏或者给观众通过社交平台分享的机会。原则是鼓励观众在观看展览时将自己置于一个社会环境中。
                    <br/><br/>   在主题较强的博物馆展览中，可以利用情感学习加深观众对展览主题的印象。实现共情学习的关键在于内容的呈现，需要加强主题的渲染。一方面，用叙事的方法讲故事。另一方面，通过VR技术等高沉浸感的展示技术营造氛围。
                    <br/><br/> 	保持适度沉浸，注重审美体验
                    <br/><br/>  沉浸感是虚拟现实技术应用于博物馆虚拟展览时需要关注的重要情感体验。尤其是当AR、MR技术受到技术特性的限制，导致所创造的沉浸感往往不如VR技术时，更需要关注沉浸式体验。同时，还要将沉浸感保持在适当的水平，避免沉浸感过高，导致用户产生负面情绪。在未来的博物馆虚拟展览设计中，无论采用何种技术，都需要将沉浸感作为重要的设计目标。观众的沉浸式体验需要在用户测试阶段得到验证。
                    <br/><br/>   另外，如果展览内容涉及艺术品或者展览内容会占据观众的大部分视觉通道，则需要关注观众的审美体验。艺术品本身具有极高的观赏价值，会带来良好的审美体验。在利用虚拟展览技术来讲解艺术展品时，需要尽可能保证原有的审美体验不被破坏，并尽量优化审美体验。像场景模拟这样以视觉图像为主的展览，也需要关注图像是否美观，能否给观众带来良好的视觉享受。一个以图像为中心的虚拟展览如果不能给观众带来良好的视觉体验，就会极大地破坏整体的观看体验。
                    <br/><br/>  沉浸感和审美体验共同影响观众观看展览时的情感体验，而情感体验又会与学习方法一起影响观众的参观和消费行为倾向。因此，在未来的博物馆虚拟展览设计中，需要避免注重技术功能的提升而忽视交互层面的情感体验。我们应该利用技术，但不应该受到技术的限制。

                    <br/><br/> <br/><br/>   欲了解更多信息，请访问已发表的论文。
                </div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
</div>
</template>

<script>
    export default {
        name: "Project7Zh"
    }
</script>

<style scoped>
    .paper_published {
  margin-top: 24px;
  font-size: 15px;
  color: #333;
  font-weight: 400;
  text-align: justify;
  line-height: 1.9;
  border-bottom: 1px solid #333;
  padding-bottom: 6px;
}
    .picture img{
        width: 100%;
    }
    .sub-title{
        margin-bottom: 20px;
        font-size: 15px;
        color: #666;
        font-weight: 400;
        text-align: justify;
    }
    .text{
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    .abstract{
        margin-top: 40px;
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    video{
        width: 100%;
    }
    .grid-content{
        min-height: 36px;
    }
    .video{
        margin-top: 100px;
    }
    .title{
        margin-top: 100px;
        text-align: center;

    }
    .title a{
        color: #333;
    }
    .title p{
        color: #aaa;
        line-height: 30px;
    }
    .title h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        color: #333333;
    }
</style>